import { CornerDownLeft } from 'lucide-react'
import React from 'react'
import { components } from 'react-select'
const CustomReactSelectOptions = (props) => {
    const { isFocused } = props;
    return (
        <components.Option {...props}>
            <div className="flex items-center justify-between w-full">
                <span>{props.children}</span>
                {isFocused && (
                    <CornerDownLeft size={12} aria-hidden="true" className="text-gray-500" />
                )}
            </div>
        </components.Option>
    )
}

export default CustomReactSelectOptions